import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalConfiguration extends BaseModelAPI {
	static entity = 'approvalconfiguration';
	static entityName = 'approvalconfiguration';

	constructor(){
		super();
	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.approvalTypeId = '';
			this.approvalType = {};
			this.description = '';
			this.appliedToId = '';
			this.appliedTo = {};
			this.userLevel = '';
			this.userInfoUserName = '';
			this.userInfo = {};
			this.approvalGroupId = '';
			this.approvalGroup = {};
			this.approvalConfigurationDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}